module.exports = __webpack_public_path__ + "static/media/completed-checklist.b5e8a956.svg";